import React from 'react';
import {
    Container,
    Typography,
    Box,
    Paper,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Divider,
    Button
} from '@mui/material';
import {
    Settings as SettingsIcon,
    Person,
    Notifications,
    Language,
    Security,
    Palette,
    VolumeUp,
    Construction
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Settings = () => {
    const navigate = useNavigate();

    const settingsItems = [
        { icon: <Person />, title: 'Account Settings', description: 'Manage your profile and account preferences' },
        { icon: <Notifications />, title: 'Notifications', description: 'Configure your notification preferences' },
        { icon: <Language />, title: 'Language & Region', description: 'Set your preferred language and region' },
        { icon: <Security />, title: 'Privacy & Security', description: 'Manage your privacy and security settings' },
        { icon: <Palette />, title: 'Appearance', description: 'Customize the look and feel of the app' },
        { icon: <VolumeUp />, title: 'Audio Settings', description: 'Configure audio playback preferences' },
    ];

    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            {/* Header */}
            <Box sx={{ mb: 4, textAlign: 'center' }}>
                <SettingsIcon sx={{ fontSize: 50, color: 'primary.main', mb: 2 }} />
                <Typography 
                    variant="h3" 
                    gutterBottom 
                    sx={{ 
                        fontWeight: 600,
                        color: 'primary.main'
                    }}
                >
                    Settings
                </Typography>
                <Typography variant="h6" color="text.secondary">
                    Customize your TilBuzz experience
                </Typography>
            </Box>

            {/* Settings List */}
            <Paper elevation={1} sx={{ borderRadius: 3, overflow: 'hidden' }}>
                <List sx={{ py: 0 }}>
                    {settingsItems.map((item, index) => (
                        <React.Fragment key={index}>
                            <ListItem 
                                sx={{ 
                                    py: 3,
                                    px: 3,
                                    cursor: 'pointer',
                                    '&:hover': {
                                        backgroundColor: 'action.hover'
                                    }
                                }}
                            >
                                <ListItemIcon sx={{ mr: 2 }}>
                                    <Box
                                        sx={{
                                            p: 1.5,
                                            borderRadius: 2,
                                            backgroundColor: 'primary.light',
                                            color: 'primary.contrastText',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        {item.icon}
                                    </Box>
                                </ListItemIcon>
                                <ListItemText
                                    primary={
                                        <Typography variant="h6" fontWeight="600">
                                            {item.title}
                                        </Typography>
                                    }
                                    secondary={
                                        <Typography variant="body2" color="text.secondary">
                                            {item.description}
                                        </Typography>
                                    }
                                />
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Construction color="action" />
                                    <Typography variant="caption" color="text.secondary">
                                        Coming Soon
                                    </Typography>
                                </Box>
                            </ListItem>
                            {index < settingsItems.length - 1 && <Divider />}
                        </React.Fragment>
                    ))}
                </List>
            </Paper>

            {/* Footer */}
            <Box sx={{ mt: 4, textAlign: 'center' }}>
                <Typography variant="body2" color="text.secondary" paragraph>
                    Settings functionality is currently under development.
                </Typography>
                <Button
                    variant="outlined"
                    onClick={() => navigate('/profile')}
                    sx={{
                        textTransform: 'none',
                        fontWeight: 600,
                        px: 3,
                        py: 1.5
                    }}
                >
                    Back to Home
                </Button>
            </Box>
        </Container>
    );
};

export default Settings; 